<template>
  <SpectreToastGroup :toasts="queue" />
  <div class="sticky top-0 z-50 min-h-16">
    <SpectreNavigationBar
      ref="navElement"
      class="fixed top-0 lg:relative"
      :account-service-url="null"
      :current-account-id="null"
      :config="{
        applicationName: null,
        environmentBadge: null,
        salesLinks: null,
        lettingsLinks: null,
        isAdmin: false,
        printAdminLinks: null,
        identityAdminLinks: null,
        emailLinks: null,
        insightsLinks,
        printSalesLinks: null,
        socialLinks: null,
        printLettingsLinks: null,
        accountLinks: null,
        websitesLinks: null,
        mobileLinks: [
          {
            icon: null,
            title: 'MobileUserDropdownMenu',
            description: '',
            badge: null,
            link: null,
            isInertia: null,
            subLinks: [
              {
                title: 'Logout',
                badge: null,
                link: '/logout',
                isInertia: false,
              }
            ],
          },
        ],
        userLinks: null,
        credits: null,
        fullBranchName: null,
        userName: page.props.auth.user?.name ?? '',
        showSalesUpsellBanner: null,
        showLettingsUpsellBanner: null,
        csrfToken: page.props.csrf_token,
      }"
      :logout-link="route('logout')"
      :has-insights-enabled="true"
      :user-uuid="page.props.auth.user?.spectreUserId ?? ''"
      :environment="page.props.app.env"
      @inertia-link-click="handleInertiaLinkClick"
    />
  </div>
  <slot />
</template>

<script setup lang="ts">
import {
  ComponentPublicInstance,
  computed,
  nextTick,
  onMounted,
  ref,
} from 'vue';
import { route } from 'ziggy-js';
import { router, usePage } from '@inertiajs/vue3';
import { SpectreNavigationBar, SpectreToastGroup } from '@agentsoftware/spectre-ui';
import NavigationLinks from '@/Config/NavigationLinks';
import useToastQueue from '@/Stores/ToastQueue';
import { trackUser } from '@/Support/MixpanelTracking';
import { whenever } from '@vueuse/core';
import { useNavigationBarStore } from '@/Stores/NavigationBar';

const page = usePage();

const { enqueue, queue } = useToastQueue();

whenever(() => page.props.flash.toasts, (newValue) => {
  newValue.forEach((toast) => {
    enqueue(toast.label, toast.description, toast.type);
  });
});

const insightsLinks = computed(() => (page.props.app.env === 'local' ? NavigationLinks : null));

const handleInertiaLinkClick = (link: string) => {
  router.get(link);
};

if (page.props.auth.user?.id) {
  trackUser(
    page.props.auth.user.id,
    {
      $email: page.props.auth.user.email,
      $name: page.props.auth.user.name,
    },
  );
}

const navElement = ref<ComponentPublicInstance>();
const navigationBarStore = useNavigationBarStore();

onMounted(() => {
  nextTick(() => {
    if (navElement.value) {
      navigationBarStore.setNavBarHeight(navElement.value?.$el.offsetHeight);
    }
  });
});
</script>

<style>
.mapboxgl-marker {
  outline: none;
}
</style>
